import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import BeneficiaryTypeAccessContent from '@UI/Pages/Administration/SubjectTypes/BeneficiaryTypeAccess/BeneficiaryTypeAccessContent';
import SubjectTypesNotifications from '@UI/Pages/Administration/SubjectTypes/Shared/SubjectTypesNotifications';
import type * as React from 'react';

const DESCRIPTION =
	"Les rôles et personnes listés ici accèdent aux dossiers des bénéficiaires. « Superviser » donne accès à tous les dossiers des agences de la personne, et le droit d'y affecter des référents.";

/** Access to the system beneficiary type: who may use it, and at which level. */
const BeneficiaryTypeAccessPage: React.FC = () => {
	return (
		<PageContainer width="md">
			<PageHeader eyebrow="CONFIGURATION" title="Bénéficiaires" description={DESCRIPTION} />
			<BeneficiaryTypeAccessContent />
			<SubjectTypesNotifications />
		</PageContainer>
	);
};

export default BeneficiaryTypeAccessPage;
